<template>
  <div v-if="showUpsellModal"
    class="relative flex items-center justify-center customPopup2 fixed w-full h-full z-[21474830004] left-0 top-0"
    id="tail">
    <div id="modal_1"
      class="flex overflow-auto fixed top-0 z-50 items-start w-full h-screen bg-black bg-opacity-80">
      <div
        class="flex justify-center items-center px-4 py-4 mx-auto w-full max-w-6xl md:px-10 md:py-10 lg:py-20 lg:px-20 xs-max:relative">
        <div :id="`mf-wrapper-${uniqueId}`"
          class="flex relative flex-col justify-center items-center w-full max-w-screen-lg bg-white rounded-b-xl border-t-8 border-yellow-600 shadow-2xl md:w-auto mf-wrapper">
          <button @click="handleDecline"
            class="absolute top-3 right-4 z-10 text-white cursor-pointer sm-max:right-1 lg:top-3.5 lg:right-6 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
            aria-label="close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round"
                stroke-linejoin="round"></path>
              <path d="M6 6L18 18" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round"
                stroke-linejoin="round"></path>
            </svg>
          </button>
          <!-- 1. STICKY BAR -->
          <div class="mf-sticky-bar sm-max:!pl-1 sm-max:!pr-8">
            <span class="sm-max:text-sm">{{ topBarText }}</span>
            <span class="timer-pill" :id="`mf-timer-${uniqueId}`">{{ formattedTime }}</span>
          </div>

          <!-- 2. HERO SECTION -->
          <div class="mf-hero">
            <div class="mf-container">
              <div class="mf-hero-grid">
                <div class="mf-hero-content">
                  <!-- Mobile Floated Image -->
                  <div class="block float-right relative mb-2 ml-3 w-5/12 mf-product-img-wrapper lg:hidden">
                    <div class="badge-save" style="font-size:10px; padding:4px 8px; top:10px; right:10px;">{{
                      saveBadgeText }}</div>
                    <img class="block w-full rounded-lg" v-if="productImage" :src="productImage" alt="MindFlow Bundle">
                  </div>

                  <h1 class="mf-h1 md-max:!mb-2 sm-max:!text-lg sm-max:!leading-5">{{ heroHeadline }}</h1>
                  <p class="mf-p md-max:!mb-1.5">{{ heroSubcopy }}</p>

                  <span class="stock-text md-max:!mt-0 sm-max:!mb-1"
                    v-html="stockText.replace('{{ stockLeft }}', stockLeft)"></span>
                  <div class="stock-meter-container">
                    <div class="stock-meter-fill" :style="{ width: `${stockPercent}%` }"></div>
                  </div>

                  <ul class="md-max:!flex-col flex gap-x-2 sm-max:!mt-0"
                    style="list-style:none; padding:0; margin-top:15px;">
                    <li class="md-max:!text-sm sm-max:!mb-0" style="margin-bottom:8px;"><span
                        style="color:var(--success-green);">✔</span> <strong v-html="benefit1"></strong></li>
                    <li class="md-max:!text-sm sm-max:!mb-0"><span style="color:var(--success-green);">✔</span> <strong
                        v-html="benefit2"></strong></li>
                  </ul>
                </div>

                <div class="hidden w-full mf-product-img-wrapper lg:block">
                  <div class="badge-save">{{ saveBadgeText }}</div>
                  <img class="block w-full" v-if="productImage" :src="productImage" alt="MindFlow Bundle">
                  <div v-else
                    style="background:#f4f4f4; height:300px; display:flex; align-items:center; justify-content:center;">
                    Product Image Placeholder
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 5. OFFER STACK -->
          <div class="mf-container md:!mb-6 !mb-0">
            <div class="mf-offer-box md-max:!mb-0 md-max:!mt-2">
              <h2 class="mf-h2 md-max:w-lg !leading-6 px-2 sm-max:!text-22 sm-max:!leading-5 sm-max:!mb-1">Here’s
                Everything You Get
                Today</h2>

              <div class="mf-price-lock md-max:!py-1">
                <div class="flex flex-wrap gap-x-3 justify-center items-center md:gap-y-1">
                  <div class="mf-old-price" style="margin:0; font-size: 14px;">Future Price: $107.97 + Shipping</div>
                  <div class="mf-new-price sm-max:!leading-none" style="font-size: 24px;">{{ offerPrice }}</div>
                  <div style="color: var(--success-green); font-weight: 700; font-size: 13px;">(FREE Priority Shipping)
                  </div>
                </div>
              </div>

              <ul class="!py-2 md-max:!gap-y-1 sm-max:!py-1"
                style="list-style:none; padding:0; margin-bottom:10px; text-align: center; display: flex; flex-wrap: wrap; justify-content: center; gap: 15px;">
                <li class="md-max:text-sm"><span style="color:var(--success-green);">✔</span> <strong>3 Extra
                    Bags</strong> (486g)</li>
                <li class="md-max:text-sm"><span style="color:var(--success-green);">✔</span> <strong>FREE
                    Shipping</strong></li>
                <li class="md-max:text-sm"><span style="color:var(--success-green);">✔</span> <strong>60-Day
                    Guarantee</strong></li>
              </ul>

              <!-- ADD TO CART BUTTON -->
              <!-- ADD TO CART BUTTON -->
              <div class="mx-4">
                <button @click="handleUpgrade"
                  class="mf-btn-primary md-max:text-lg md-max:!px-2 md-max:!py-2 md-max:!leading-6"> YES,
                  Upgrade My Order (ONE CLICK) </button>
              </div>

              <div class="md-max:flex md-max:flex-col md-max:!mt-2 md-max:!gap-y-1"
                style="margin-top: 20px; display: flex; justify-content: center; align-items: center; gap: 10px; font-size: 13px; color: #777;">
                <span>🛡️ 60 days Money Back Guarantee</span> <span class="md-max:hidden">|</span> <span>🔒 SSL
                  Secure</span>
              </div>
              <button @click="handleDecline" class="mf-decline-link md-max:!mt-2" :id="`mf-decline-${uniqueId}`">No
                thanks, I'll pass
                on
                the savings for now.</button>
            </div>
          </div>



          <!-- 8. COMPLIANCE -->
          <!-- <div class="mf-footer-compliance">
            <div class="mf-container">
              <p>These statements have not been evaluated by the Food and Drug Administration.</p>
              <p>MindFlow is not intended to diagnose, treat, cure, or prevent any disease.</p>
              <p>Savings based on current one-time price of $36/bag plus $9.95 shipping.</p>
              <p>Consult your healthcare professional before use if pregnant, nursing, or taking medication.</p>
              <p>Testimonials are unpaid, supplied by verified purchasers, and substantively typical.</p>
            </div>
          </div> -->

          <!-- SOCIAL PROOF TOAST CONTAINER -->
          <div :id="`mf-social-toast-${uniqueId}`" class="social-toast" :class="{ show: showToast }">
            <div class="toast-initials">{{ currentToast.initials }}</div>
            <div class="toast-content">
              <h4 style="margin:0; font-size:14px; font-weight:700;">{{ currentToast.name }}</h4>
              <p style="margin:0; font-size:12px; color:#666;">Just upgraded to the 6-Bag Bundle.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import ProductOffer from '../content/ProductOffer.vue';

const { registerUpsell, unregisterUpsell, showUpsellModal } = useUpsell();
const cart = useCart();

const props = defineProps({
  topBarText: {
    type: String,
    default: '⚡ High Demand: Offer reserved for'
  },
  heroHeadline: {
    type: String,
    default: 'Wait—Before You Go! Lock-In 3 More Bags of MindFlow at the Insider Rate of ONLY 21.59 per bag (That’s 40% OFF Retail)'
  },
  heroSubcopy: {
    type: String,
    default: 'Congrats—your first order of MindFlow is on its way. But there’s one problem most first-time buyers run into… They run out just as the mental magic starts to build.'
  },
  productImage: {
    type: String,
    default: ''
  },
  stockLeft: {
    type: Number,
    default: 12
  },
  stockPercent: {
    type: Number,
    default: 85
  },
  offerPrice: {
    type: String,
    default: '$64.78'
  },
  productVariantId: {
    type: String,
    default: '' // Required
  },
  stockText: {
    type: String,
    default: '🔥 Only {{ stockLeft }} promotional bundles left today'
  },
  benefit1: {
    type: String,
    default: 'Save $100+ Instantly'
  },
  benefit2: {
    type: String,
    default: 'Skip the shipping fees'
  },
  saveBadgeText: {
    type: String,
    default: 'SAVE 40%'
  },
  comparisonTitle: {
    type: String,
    default: 'Why Another 3 Bags Is a Brain-Smart Move'
  },
  comparisonCol1Title: {
    type: String,
    default: 'Without This Upsell'
  },
  comparisonCol2Title: {
    type: String,
    default: 'With This Upsell'
  },
  comparisonRows: {
    type: Array,
    default: () => [
      { col1: '❌ Risk running out in less than 3 months and losing momentum', col2: '✅ <strong>Stay in the Growth Zone</strong> for 5 months—no "gap weeks"' },
      { col1: '❌ Pay full price later ($36 / bag) + shipping', col2: '✅ <strong>Instant $100+ in savings</strong> and we cover the shipping' },
      { col1: '❌ Start-and-stop habit (inconsistent benefits)', col2: '✅ Daily nutrient saturation—key nootropics can work better with time' },
      { col1: '❌ Could get Brain fog again', col2: '✅ Focus becomes your new normal' }
    ]
  },
  graphTitle: {
    type: String,
    default: 'The Compounding Effect: Your Brain on Month 5 vs. Month 1'
  },
  graphSubtitle: {
    type: String,
    default: 'Why real results come from sticking with it—not trying it once'
  },
  graphDescription: {
    type: String,
    default: "It's the compound effect of giving your brain what it needs—consistently. Mindflow is designed to support optimal brain function over time, helping you feel sharper, more focused, and more energized."
  },
  graphQuote: {
    type: String,
    default: 'Think weeks, not minutes.<br>Habits, not hacks.'
  },
  graphLabelX1: {
    type: String,
    default: 'Day 1'
  },
  graphLabelX2: {
    type: String,
    default: 'Week 4 (Adapt)'
  },
  graphLabelX3: {
    type: String,
    default: 'Week 12 (Build)'
  },
  graphLabelY: {
    type: String,
    default: 'Brain Support Level'
  },
  offerTitle: {
    type: String,
    default: 'Here’s Everything You Get Today'
  },
  futurePriceText: {
    type: String,
    default: 'Future Price: $216.00 + Shipping'
  },
  shippingIncludedText: {
    type: String,
    default: '(FREE Priority Shipping Included)'
  },
  offerItems: {
    type: Array,
    default: () => [
      { text: '3 Extra Bags of MindFlow (486g total)' },
      { text: 'FREE Priority Shipping' },
      { text: '“Keep-Flowing” 60 days Guarantee' }
    ]
  },
  ctaButtonText: {
    type: String,
    default: 'YES, Upgrade My Order (ONE CLICK)'
  },
  guaranteeText1: {
    type: String,
    default: '🛡️ 60-Day Money Back Guarantee'
  },
  guaranteeText2: {
    type: String,
    default: '🔒 SSL Secure'
  },
  declineText: {
    type: String,
    default: "No thanks, I'll pass on the savings for now."
  },
  faqTitle: {
    type: String,
    default: 'FAQs (Rapid-Fire)'
  },
  faqs: {
    type: Array,
    default: () => [
      { question: 'Will six bags stay fresh?', answer: 'Yes—our nitro-flush packaging keeps MindFlow peak-fresh for 12 months.' },
      { question: 'I just bought—will this delay shipment?', answer: 'Not at all. Your original order and add-on ship together, same fast timeline.' },
      { question: 'What if I change my mind?', answer: 'You’re covered by the 60-day “Get In Flow” guarantee—hassle-free refunds.' }
    ]
  },
  finalCallTitle: {
    type: String,
    default: 'Final Call: Momentum Loves Speed'
  },
  finalCallDescription: {
    type: String,
    default: 'Your brain thrives on consistency. Skip the re-order scramble, sidestep retail pricing, and glide through the next 5 months with uninterrupted MindFlow.'
  },
  finalCallButtonText: {
    type: String,
    default: '👉 YES, Upgrade My Order to 3 More Bags for {{ offerPrice }}'
  },
  complianceText: {
    type: String,
    default: '<p>These statements have not been evaluated by the Food and Drug Administration.</p><p>MindFlow is not intended to diagnose, treat, cure, or prevent any disease.</p><p>Savings based on current one-time price of $36/bag plus $9.95 shipping.</p><p>Consult your healthcare professional before use if pregnant, nursing, or taking medication.</p><p>Testimonials are unpaid, supplied by verified purchasers, and substantively typical.</p>'
  },
  toastText: {
    type: String,
    default: 'Just upgraded to the 6-Bag Bundle.'
  }
});

const uniqueId = Math.random().toString(36).substr(2, 9);
const timeLeft = ref(600); // 10 minutes
const showToast = ref(false);
const currentToast = ref({ name: '', initials: '' });

const handleUpgrade = () => {
  // Clear existing cart items to "replace" (switch) to the new variant
  // Since useCart exposes `items` as a state, we can manipulate it if we access it properly.
  // However, `useCart` only returns `items` as a readonly-ish getter in the current implementation?
  // Let's check useCart again. It returns `items` which is the `useState`.
  // So we can clear it.

  // Actually, `useCart` returns `items` function, and `items()` returns the state.
  // In setup: const cart = useCart();
  // cart.items().value = []; // This should clear it.

  if (!props.productVariantId) {
    console.error("Missing productVariantId for upsell");
    return;
  }

  const upsellItem = {
    id: props.productVariantId,
    quantity: 1,
    qty: 1 // Support both just in case
  };

  // We want to REPLACE the cart content with this new item.
  // "Switch to new variant id"

  // Option A: manipulating cart state
  cart.items().value = [upsellItem];

  // Proceed to checkout with the new single item
  cart.checkout();
};

const handleDecline = () => {
  // Proceed to checkout with original items only
  cart.checkout();
};

const formattedTime = computed(() => {
  const m = Math.floor(timeLeft.value / 60);
  const s = timeLeft.value % 60;
  return `${m}:${s < 10 ? '0' : ''}${s}`;
});

let timerInterval;
let toastInterval;
let toastTimeout;

const names = [
  'Sarah L. from Florida',
  'Mike T. from New York',
  'Jessica R. from California',
  'David B. from Ohio',
  'Emily W. from Texas',
  'James H. from London',
  'Amanda K. from Chicago',
  'Robert M. from Toronto',
  'Jennifer P. from Washington',
  'Daniel S. from Colorado',
  'Ashley G. from Arizona',
  'Michael C. from Nevada',
  'Lisa M. from Oregon',
  'Thomas B. from Michigan',
  'Nicole R. from Georgia',
  'Christopher L. from Virginia',
];

const displayToast = () => {
  const randomNameString = names[Math.floor(Math.random() * names.length)];
  const parts = randomNameString.split(' ');
  let initials = parts[0][0];
  if (parts.length > 1) initials += parts[1][0];

  currentToast.value = {
    name: randomNameString,
    initials: initials
  };

  showToast.value = true;
  toastTimeout = setTimeout(() => {
    showToast.value = false;
  }, 4000);
};

onMounted(() => {
  // 1. Countdown Timer Logic
  timerInterval = setInterval(() => {
    if (timeLeft.value > 0) {
      timeLeft.value--;
    }
  }, 1000);

  // 2. Social Proof Toast Logic
  setTimeout(displayToast, 2000);
  toastInterval = setInterval(displayToast, 12000);

  // 3. Register Upsell Availability
  registerUpsell();
});

// Handle Body Scroll Lock
watch(showUpsellModal, (newValue) => {
  if (newValue) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
});

onUnmounted(() => {
  if (timerInterval) clearInterval(timerInterval);
  if (toastInterval) clearInterval(toastInterval);
  if (toastTimeout) clearTimeout(toastTimeout);

  // Clean up
  unregisterUpsell();
  document.body.style.overflow = '';
});


defineBuilderComponent({
  friendlyName: 'MindFlow Upsell',
  inputs: [
    {
      name: 'topBarText',
      type: 'text',
      defaultValue: '⚡ High Demand: Offer reserved for',
      friendlyName: 'Top Bar Warning'
    },
    {
      name: 'heroHeadline',
      type: 'text',
      defaultValue: 'Wait—Before You Go! Lock-In 3 More Bags of MindFlow at the Insider Rate of ONLY $21.59 per bag (That’s 40% OFF Retail)',
      friendlyName: 'Hero Headline'
    },
    {
      name: 'heroSubcopy',
      type: 'longText',
      defaultValue: 'Congrats—your first order of MindFlow is on its way. But there’s one problem most first-time buyers run into… They run out just as the mental magic starts to build.',
      friendlyName: 'Hero Subcopy'
    },
    {
      name: 'productImage',
      type: 'file',
      friendlyName: 'Product Image'
    },
    {
      name: 'stockLeft',
      type: 'number',
      defaultValue: 12,
      friendlyName: 'Stock Left Number'
    },
    {
      name: 'stockPercent',
      type: 'number',
      defaultValue: 85,
      friendlyName: 'Stock Meter % Fill'
    },
    {
      name: 'offerPrice',
      type: 'text',
      defaultValue: '$64.78',
      friendlyName: 'Offer Price Display'
    },
    {
      name: 'productVariantId',
      type: 'text',
      friendlyName: 'Product Variant ID (Required)',
      helperText: 'The numeric ID of the 6-bag variant.'
    },
    {
      name: 'stockText',
      type: 'text',
      defaultValue: '🔥 Only {{ stockLeft }} promotional bundles left today',
      friendlyName: 'Stock Text (use {{ stockLeft }})'
    },
    {
      name: 'benefit1',
      type: 'richText',
      defaultValue: 'Save $100+ Instantly',
      friendlyName: 'Benefit 1'
    },
    {
      name: 'benefit2',
      type: 'richText',
      defaultValue: 'Skip the shipping fees',
      friendlyName: 'Benefit 2'
    },
    {
      name: 'saveBadgeText',
      type: 'text',
      defaultValue: 'SAVE 40%',
      friendlyName: 'Save Badge Text'
    },
    {
      name: 'comparisonTitle',
      type: 'richText',
      defaultValue: 'Why Another 3 Bags Is a Brain-Smart Move',
      friendlyName: 'Comparison Title'
    },
    {
      name: 'comparisonCol1Title',
      type: 'text',
      defaultValue: 'Without This Upsell',
      friendlyName: 'Comparison Col 1 Title'
    },
    {
      name: 'comparisonCol2Title',
      type: 'text',
      defaultValue: 'With This Upsell',
      friendlyName: 'Comparison Col 2 Title'
    },
    {
      name: 'comparisonRows',
      type: 'list',
      subFields: [
        { name: 'col1', type: 'richText' },
        { name: 'col2', type: 'richText' }
      ],
      defaultValue: [
        { col1: '❌ Risk running out in less than 3 months and losing momentum', col2: '✅ <strong>Stay in the Growth Zone</strong> for 5 months—no "gap weeks"' },
        { col1: '❌ Pay full price later ($36 / bag) + shipping', col2: '✅ <strong>Instant $100+ in savings</strong> and we cover the shipping' },
        { col1: '❌ Start-and-stop habit (inconsistent benefits)', col2: '✅ Daily nutrient saturation—key nootropics can work better with time' },
        { col1: '❌ Could get Brain fog again', col2: '✅ Focus becomes your new normal' }
      ],
      friendlyName: 'Comparison Rows'
    },
    {
      name: 'graphTitle',
      type: 'richText',
      defaultValue: 'The Compounding Effect: Your Brain on Month 5 vs. Month 1',
      friendlyName: 'Graph Title'
    },
    {
      name: 'graphSubtitle',
      type: 'richText',
      defaultValue: 'Why real results come from sticking with it—not trying it once',
      friendlyName: 'Graph Subtitle'
    },
    {
      name: 'graphDescription',
      type: 'richText',
      defaultValue: "It's the compound effect of giving your brain what it needs—consistently. Mindflow is designed to support optimal brain function over time, helping you feel sharper, more focused, and more energized.",
      friendlyName: 'Graph Description'
    },
    {
      name: 'graphQuote',
      type: 'richText',
      defaultValue: 'Think weeks, not minutes.<br>Habits, not hacks.',
      friendlyName: 'Graph Quote'
    },
    {
      name: 'graphLabelX1',
      type: 'text',
      defaultValue: 'Day 1',
      friendlyName: 'Graph Label X1'
    },
    {
      name: 'graphLabelX2',
      type: 'text',
      defaultValue: 'Week 4 (Adapt)',
      friendlyName: 'Graph Label X2'
    },
    {
      name: 'graphLabelX3',
      type: 'text',
      defaultValue: 'Week 12 (Build)',
      friendlyName: 'Graph Label X3'
    },
    {
      name: 'graphLabelY',
      type: 'text',
      defaultValue: 'Brain Support Level',
      friendlyName: 'Graph Label Y'
    },
    {
      name: 'offerTitle',
      type: 'richText',
      defaultValue: 'Here’s Everything You Get Today',
      friendlyName: 'Offer Title'
    },
    {
      name: 'futurePriceText',
      type: 'richText',
      defaultValue: 'Future Price: $216.00 + Shipping',
      friendlyName: 'Future Price Text'
    },
    {
      name: 'shippingIncludedText',
      type: 'richText',
      defaultValue: '(FREE Priority Shipping Included)',
      friendlyName: 'Shipping Included Text'
    },
    {
      name: 'offerItems',
      type: 'list',
      subFields: [
        { name: 'text', type: 'richText' }
      ],
      defaultValue: [
        { text: '3 Extra Bags of MindFlow (486g total)' },
        { text: 'FREE Priority Shipping' },
        { text: '“Keep-Flowing” 60 days Guarantee' }
      ],
      friendlyName: 'Offer Items'
    },
    {
      name: 'ctaButtonText',
      type: 'text',
      defaultValue: 'YES, Upgrade My Order (ONE CLICK)',
      friendlyName: 'CTA Button Text'
    },
    {
      name: 'guaranteeText1',
      type: 'text',
      defaultValue: '🛡️ 60-Day Money Back Guarantee',
      friendlyName: 'Guarantee Text 1'
    },
    {
      name: 'guaranteeText2',
      type: 'text',
      defaultValue: '🔒 SSL Secure',
      friendlyName: 'Guarantee Text 2'
    },
    {
      name: 'declineText',
      type: 'text',
      defaultValue: "No thanks, I'll pass on the savings for now.",
      friendlyName: 'Decline Text'
    },
    {
      name: 'faqTitle',
      type: 'richText',
      defaultValue: 'FAQs (Rapid-Fire)',
      friendlyName: 'FAQ Title'
    },
    {
      name: 'faqs',
      type: 'list',
      subFields: [
        { name: 'question', type: 'richText' },
        { name: 'answer', type: 'richText' }
      ],
      defaultValue: [
        { question: 'Will six bags stay fresh?', answer: 'Yes—our nitro-flush packaging keeps MindFlow peak-fresh for 12 months.' },
        { question: 'I just bought—will this delay shipment?', answer: 'Not at all. Your original order and add-on ship together, same fast timeline.' },
        { question: 'What if I change my mind?', answer: 'You’re covered by the 60-day “Get In Flow” guarantee—hassle-free refunds.' }
      ],
      friendlyName: 'FAQs'
    },
    {
      name: 'finalCallTitle',
      type: 'richText',
      defaultValue: 'Final Call: Momentum Loves Speed',
      friendlyName: 'Final Call Title'
    },
    {
      name: 'finalCallDescription',
      type: 'richText',
      defaultValue: 'Your brain thrives on consistency. Skip the re-order scramble, sidestep retail pricing, and glide through the next 5 months with uninterrupted MindFlow.',
      friendlyName: 'Final Call Description'
    },
    {
      name: 'finalCallButtonText',
      type: 'text',
      defaultValue: '👉 YES, Upgrade My Order to 3 More Bags for {{ offerPrice }}',
      friendlyName: 'Final Call Button Text (use {{ offerPrice }})'
    },
    {
      name: 'complianceText',
      type: 'richText',
      defaultValue: '<p>These statements have not been evaluated by the Food and Drug Administration.</p><p>MindFlow is not intended to diagnose, treat, cure, or prevent any disease.</p><p>Savings based on current one-time price of $36/bag plus $9.95 shipping.</p><p>Consult your healthcare professional before use if pregnant, nursing, or taking medication.</p><p>Testimonials are unpaid, supplied by verified purchasers, and substantively typical.</p>',
      friendlyName: 'Compliance Text'
    },
    {
      name: 'toastText',
      type: 'text',
      defaultValue: 'Just upgraded to the 6-Bag Bundle.',
      friendlyName: 'Toast Text'
    }
  ]
});
</script>

<style scoped>
@import "@/modal.css";

/* --- SCOPED CSS VARIABLES --- */
/* Remove fixed positioning override since we are now using the modal structure */
.mf-wrapper {
  /* Reset max-width as it is handled by the modal container */
  max-width: 100%;
  /* Remove inherited fixed positioning if any */
  position: relative;
  /* Ensure it takes full width of parent */
  width: 100%;
}

.mf-wrapper {
  --brand-primary: #1a1a1a;
  --brand-gold: #D4AF37;
  --brand-gold-gradient: linear-gradient(135deg, #b88b40 0%, #ebd197 50%, #b88b40 100%);
  --brand-urgent: #E55646;
  --bg-light: #F9FAFB;
  --bg-white: #FFFFFF;
  --text-dark: #2B2B2B;
  --text-body: #4A4A4A;
  --success-green: #2E7D32;
  --shadow-soft: 0 10px 40px rgba(0, 0, 0, 0.08);
  --shadow-sharp: 0 4px 12px rgba(0, 0, 0, 0.12);
  --font-head: 'Montserrat', sans-serif;
  --font-body: 'Open Sans', sans-serif;
}

.mf-wrapper {
  position: relative;
  width: 100%;
  height: auto;
  /* max-width: none; Removed to allow Tailwind max-w-screen-lg */
  background: var(--bg-white);
  display: block;
  opacity: 1;
  z-index: 1;
}

.mf-container {
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
}

/* --- ANIMATIONS --- */
@keyframes pulse-gold {
  0% {
    box-shadow: 0 0 0 0 rgba(212, 175, 55, 0.7);
  }

  70% {
    box-shadow: 0 0 0 15px rgba(212, 175, 55, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(212, 175, 55, 0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* --- TYPOGRAPHY --- */
.mf-h1 {
  font-family: var(--font-head);
  font-weight: 800;
  font-size: 32px;
  line-height: 1.2;
  margin-bottom: 15px;
  margin-top: 0;
  color: var(--text-dark);
  letter-spacing: -0.5px;
}

.mf-h2 {
  font-family: var(--font-head);
  font-weight: 700;
  font-size: 26px;
  margin-bottom: 12px;
  margin-top: 0;
  color: var(--text-dark);
}

.mf-h3 {
  font-family: var(--font-head);
  font-weight: 500;
  font-size: 18px;
  margin-top: -8px;
  margin-bottom: 25px;
  color: #666;
}

.mf-p {
  font-size: 17px;
  line-height: 1.6;
  margin-bottom: 15px;
}

.text-center {
  text-align: center;
}

.text-gradient {
  background: var(--brand-gold-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* --- 1. STICKY URGENCY BAR --- */
.mf-sticky-bar {
  background: #222;
  color: white;
  padding: 12px;
  text-align: center;
  font-weight: 600;
  font-family: var(--font-head);
  font-size: 14px;
  letter-spacing: 0.5px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.timer-pill {
  background: var(--brand-urgent);
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 800;
  font-family: monospace;
  font-size: 15px;
}

/* --- 2. HERO SECTION --- */
.mf-hero {
  padding: 10px 0px;
  border-bottom: 1px solid #f0f0f0;
}

.mf-hero-grid {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 40px;
  align-items: center;
}

.stock-meter-container {
  margin: 20px 0;
  background: #eee;
  border-radius: 10px;
  height: 10px;
  overflow: hidden;
  position: relative;
}

.stock-meter-fill {
  height: 100%;
  background: var(--brand-urgent);
  width: 85%;
  border-radius: 10px;
  position: relative;
  background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.stock-text {
  font-size: 13px;
  color: var(--brand-urgent);
  font-weight: 700;
  margin-top: -15px;
  display: block;
  margin-bottom: 15px;
}

.mf-product-img-wrapper {
  position: relative;
  border-radius: 12px;
  box-shadow: var(--shadow-sharp);
  overflow: hidden;
}

.badge-save {
  position: absolute;
  top: 20px;
  right: 20px;
  background: var(--brand-urgent);
  color: white;
  padding: 8px 15px;
  border-radius: 50px;
  font-weight: 800;
  font-size: 14px;
  box-shadow: 0 4px 10px rgba(229, 86, 70, 0.4);
  animation: slideInUp 0.5s ease-out;
  z-index: 2;
}

/* --- 3. COMPARISON TABLE --- */
.mf-table-section {
  padding: 50px 40px;
  background: #fff;
}

.mf-compare-wrapper {
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  border: 1px solid #eee;
}

.mf-compare-table {
  width: 100%;
  border-collapse: collapse;
}

.mf-compare-table th {
  padding: 18px;
  font-family: var(--font-head);
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1px;
}

.mf-compare-table td {
  padding: 20px;
  vertical-align: middle;
  border-bottom: 1px solid #eee;
  font-size: 15px;
}

.th-neg {
  background: #fdf2f2;
  color: var(--brand-urgent);
}

.th-pos {
  background: #e8f5e9;
  color: var(--success-green);
}

.col-neg {
  background-color: #fff;
  border-left: 5px solid transparent;
  color: #888;
}

.col-pos {
  background-color: #fcfcfc;
  border-left: 5px solid var(--success-green);
  font-weight: 600;
  color: #333;
}

/* --- 4. CONSISTENCY GRAPH --- */
.mf-compound-section {
  padding: 60px 40px;
  background: linear-gradient(to bottom, #f9fafb, #fff);
  text-align: center;
}

.graph-container {
  margin: 40px auto;
  max-width: 600px;
  height: 250px;
  position: relative;
  border-left: 2px solid #ccc;
  border-bottom: 2px solid #ccc;
}

.graph-path {
  fill: none;
  stroke: var(--brand-gold);
  stroke-width: 4;
  stroke-linecap: round;
  filter: drop-shadow(0px 4px 4px rgba(212, 175, 55, 0.4));
}

.graph-label-x {
  position: absolute;
  bottom: -30px;
  font-size: 12px;
  color: #666;
  font-weight: bold;
  width: 100px;
  text-align: center;
}

.graph-label-y {
  position: absolute;
  left: -40px;
  top: 50%;
  transform: rotate(-90deg);
  font-size: 12px;
  color: #666;
  font-weight: bold;
}

/* --- 5. OFFER STACK --- */
.mf-offer-box {
  background: #fffefc;
  border: 2px solid #e6c873;
  border-radius: 12px;
  padding: 15px 0px;
  margin: 10px 0px 15px 0px;
  text-align: center;
  position: relative;
  box-shadow: 0 10px 30px rgba(212, 175, 55, 0.15);
  overflow: hidden;
}

.mf-offer-box::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 6px;
  background: var(--brand-gold-gradient);
}

.mf-price-lock {
  margin-bottom: 5px;
  padding: 8px 15px;
  background: rgba(232, 245, 233, 0.5);
  border: 1px solid rgba(46, 125, 50, 0.1);
  border-radius: 8px;
  display: inline-block;
  width: 100%;
}

.mf-old-price {
  text-decoration: line-through;
  color: #999;
  font-size: 16px;
  margin-bottom: 5px;
}

.mf-new-price {
  color: var(--success-green);
  font-weight: 800;
  font-size: 28px;
  letter-spacing: -1px;
}

.mf-btn-primary {
  background: #F1574B;
  color: #fff;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  font-family: var(--font-head);
  font-weight: 800;
  font-size: 20px;
  padding: 16px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
  text-decoration: none;
  display: block;
  box-sizing: border-box;
  transition: all 0.2s ease;
  box-shadow: 0 4px 15px rgba(184, 139, 64, 0.4);
}

.mf-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(184, 139, 64, 0.6);
}

.mf-decline-link {
  display: inline-block;
  margin-top: 20px;
  color: #999;
  font-size: 14px;
  text-decoration: underline;
}

/* --- 6. FAQs & Footer --- */
.mf-faq-section {
  padding: 40px;
  background: #fff;
  border-top: 1px solid #f0f0f0;
}

.mf-faq-item {
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
  padding-bottom: 20px;
}

.mf-faq-q {
  font-weight: 700;
  color: var(--text-dark);
  margin-bottom: 8px;
  font-family: var(--font-head);
}

.mf-faq-q::before {
  content: "Q:";
  color: var(--brand-gold);
  margin-right: 10px;
  font-weight: 800;
}

.mf-faq-a {
  color: var(--text-body);
  font-size: 15px;
  margin-left: 28px;
}

.mf-final-call {
  padding: 50px 40px;
  background: #fdfaf4;
  text-align: center;
  border-top: 1px solid #eee;
}

.mf-footer-compliance {
  padding: 40px;
  background: #f9fafb;
  font-size: 11px;
  color: #999;
  text-align: center;
  line-height: 1.6;
  border-top: 1px solid #eee;
}

.mf-footer-compliance p {
  margin: 0 0 10px 0;
}

/* --- TOAST --- */
.social-toast {
  position: fixed;
  bottom: 20px;
  left: 20px;
  background: white;
  padding: 15px 20px;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 15px;
  z-index: 10010;
  transform: translateY(20px);
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s ease;
  border-left: 4px solid var(--success-green);
  max-width: 300px;
}

.social-toast.show {
  transform: translateY(0);
  opacity: 1;
  visibility: visible;
}

.toast-initials {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, var(--brand-urgent), #ff7e67);
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 800;
  font-size: 18px;
  line-height: 1;
  flex-shrink: 0;
  box-shadow: 0 4px 10px rgba(229, 86, 70, 0.3);
  text-transform: uppercase;
  font-family: var(--font-head);
}


@media(max-width: 1024px) {
  .mf-hero-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}

@media(max-width: 768px) {

  .mf-compound-section {
    padding: 24px 40px !important;
  }

  .mf-hero {
    padding: 12px 12px;
  }

  .mf-sticky-bar {
    font-size: 15px !important;
  }

  .mf-table-section .mf-container,
  .mf-compound-section .mf-container {
    padding: 0 !important;
  }

  .mf-container {
    padding: 0px 0px !important;
  }

  .stock-meter-container {
    margin: 6px 0 !important;
  }

  .mf-offer-box {
    margin: 10px 10px 10px 10px !important;
  }

  .mf-table-section {
    padding: 24px 30px !important;
  }

  .mf-compound-section {
    padding: 24px 24px !important;
  }

  .mf-final-call {
    padding: 14px 20px !important;
  }



  .mf-h1 {
    font-size: 20px;
  }

  .mf-p {
    font-size: 15px;
    line-height: 18px;
  }

  .mf-compare-table th {
    display: none;
  }

  .mf-compare-table td {
    display: block;
    width: 100%;
    text-align: left;
    border: none;
    padding: 10px 15px;
  }

  .mf-compare-table tr {
    border-bottom: 1px solid #eee;
    display: block;
    margin-bottom: 15px;
  }

  .col-pos {
    border-left: 4px solid var(--success-green);
    background: #f9fdfa;
  }
}
</style>
